import {
  address1,
  address2,
  city,
  fax,
  firstName,
  email as emailCommon,
  lastName,
  organization,
  phone,
  state,
  zip
} from '@/components/requestWizard/contactInfoFields';

export const email = {
  ...emailCommon,
  rules: {
    ...emailCommon.rules,
    max: 50,
    required: false
  }
};

export {
  address1,
  address2,
  city,
  fax,
  firstName,
  lastName,
  organization,
  phone,
  state,
  zip
};
